import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-gray-dark text-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" data-discover="true" className="flex items-center space-x-2">
            <img 
              src="/images/favicon.webp" 
              alt="Sceptre Slots" 
              className="w-10 h-10 rounded-lg"
              itemprop="logo"
            />
            <span className="text-xl font-bold" itemprop="name">Sceptre Slots</span>
          </Link>

          <nav className="hidden md:flex items-center space-x-6">
            <Link to="/" data-discover="true" className="hover:text-yellow-accent transition-colors">
              Home
            </Link>
            <Link to="/guides" data-discover="true" className="hover:text-yellow-accent transition-colors">
              Guides
            </Link>
            <Link to="/news" data-discover="true" className="hover:text-yellow-accent transition-colors">
              News
            </Link>
            <Link to="/reviews" data-discover="true" className="hover:text-yellow-accent transition-colors">
              Reviews
            </Link>
            <Link to="/slots" data-discover="true" className="hover:text-yellow-accent transition-colors">
              Slots
            </Link>
          </nav>

          <button
            className="md:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 space-y-3">
            <Link
              to="/"
              data-discover="true"
              className="block hover:text-yellow-accent transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/guides"
              data-discover="true"
              className="block hover:text-yellow-accent transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Guides
            </Link>
            <Link
              to="/news"
              data-discover="true"
              className="block hover:text-yellow-accent transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              News
            </Link>
            <Link
              to="/reviews"
              data-discover="true"
              className="block hover:text-yellow-accent transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Reviews
            </Link>
            <Link
              to="/slots"
              data-discover="true"
              className="block hover:text-yellow-accent transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Slots
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;

